"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutConfirmToJSON = exports.CheckoutConfirmFromJSONTyped = exports.CheckoutConfirmFromJSON = exports.instanceOfCheckoutConfirm = void 0;
var runtime_1 = require("../runtime");
var CartSummary_1 = require("./CartSummary");
var CheckoutError_1 = require("./CheckoutError");
/**
 * Check if a given object implements the CheckoutConfirm interface.
 */
function instanceOfCheckoutConfirm(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCheckoutConfirm = instanceOfCheckoutConfirm;
function CheckoutConfirmFromJSON(json) {
    return CheckoutConfirmFromJSONTyped(json, false);
}
exports.CheckoutConfirmFromJSON = CheckoutConfirmFromJSON;
function CheckoutConfirmFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': !(0, runtime_1.exists)(json, 'success') ? undefined : json['success'],
        'createdAttestation': !(0, runtime_1.exists)(json, 'createdAttestation') ? undefined : json['createdAttestation'],
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : (json['errors'] === null ? null : json['errors'].map(CheckoutError_1.CheckoutErrorFromJSON)),
        'orderNumber': !(0, runtime_1.exists)(json, 'orderNumber') ? undefined : json['orderNumber'],
        'cart': !(0, runtime_1.exists)(json, 'cart') ? undefined : (0, CartSummary_1.CartSummaryFromJSON)(json['cart']),
    };
}
exports.CheckoutConfirmFromJSONTyped = CheckoutConfirmFromJSONTyped;
function CheckoutConfirmToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'cart': (0, CartSummary_1.CartSummaryToJSON)(value.cart),
    };
}
exports.CheckoutConfirmToJSON = CheckoutConfirmToJSON;
